module.exports = __webpack_public_path__ + "img/69.0099404d.png";